module.exports = __webpack_public_path__ + "img/857528a.png";